import type {RouteRecordRaw} from "vue-router";

import IconOutgoing from '@/shared/ui/icons/document/Outgoing.vue';

import {route as listRoute, routeName as listRouteName} from './list';
import {route as docRoute} from './doc';

export const routeName = 'Outgoing';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'outgoing',
    redirect: {
        name: listRouteName,
    },
    children: [
        docRoute,
        listRoute,
    ],
    meta: {
        title: 'outgoing',
        icon: IconOutgoing,
        isNavTab: true,
    }
};
